import React from 'react'
import Conditional from '../common/Conditional'
import HtmlTooltip from '../common/HtmlTooltip'
import Tooltip from '../common/Tooltip'
import { santizeHtml } from '../../models/Common'
import './FWOLabel.css'

export interface IFWOLabelHtmlProps {
  name: string
  label: string
  tooltip?: string
  htmlTooltip?: string
  defaultHtmlTooltipIconText?: string
  showOptional?: boolean
  title?: string
  required?: boolean
}

const FWOLabelHtml = (props: IFWOLabelHtmlProps) => {
  const htmlObj = { __html: santizeHtml(props.label, { ADD_ATTR: ['target'] }) }

  return (
    <>
      <label id={`${props.name}lbl`} dangerouslySetInnerHTML={htmlObj}>
        {props.showOptional && ' (optional)'}
      </label>
      <label id={`${props.name}lbl2`}>
        <Conditional if={props.tooltip?.length > 0}>
          <Tooltip>{props.tooltip}</Tooltip>
        </Conditional>
        <Conditional if={props.htmlTooltip?.length > 0}>
          <HtmlTooltip
            html={props.htmlTooltip}
            defaultIconText={props.defaultHtmlTooltipIconText}
          ></HtmlTooltip>
        </Conditional>
        {props.required && <span className="sr-only">(required)</span>}
      </label>
    </>
  )
}

export default FWOLabelHtml
